import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISystemMessage } from './models/ISystemMessage';

@Injectable({
  providedIn: 'root'
})
export class SystemMessageService {
  readonly env = environment;

  systemMessageSubject = new BehaviorSubject<ISystemMessage>(null);
  systemMessages$ = this.systemMessageSubject.asObservable();

  constructor(private http: HttpClient) { }

  setSystemMessage(message: ISystemMessage) {
    this.systemMessageSubject.next(message);
  }

  getAll(_sortType: string, _sortOrder: string, page: number, limit: number, ): Observable<any> {
    let request = {
        sortType: _sortType,
        sortOrder: _sortOrder,
        pageNumber: page,
        limit: limit
      };
    
    return this.http.post(this.env.apiUrl + '/systemMessage/All', request);
  }

  create(request: any): Observable<any> {
    return this.http.post(this.env.apiUrl + '/systemMessage/Create', request);
  }

  edit(request: any): Observable<any> {
    return this.http.put(this.env.apiUrl + '/systemMessage/Edit', request);
  }

  delete(smId: number): Observable<any> {
    return this.http.delete(this.env.apiUrl + '/systemMessage/Delete/' + smId);
  }

  getWebQulSystemMessages(): Observable<any> {
    return this.http.get(this.env.apiUrl + '/systemMessage/WebQul');
  }


}
